import { formatString } from '@pihealth/common-ui-library';
import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { workareaBaseQuery } from './workArearBaseQuery';
import { baseQuery } from './baseQuery';

export const masterListApi = createApi({
  baseQuery: workareaBaseQuery,
  reducerPath: 'masterListApi',
  endpoints: builder => ({
    getStudyDetails: builder.query<any, any>({
      query: ({ study_id, application, application_section, application_module_section }) => ({
        url: `${formatString(endPoints.masterList.getStudyDetails, {
          key: 'study_id',
          value: study_id
        })}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    getAllDepots: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section }) => ({
        url: `${formatString(endPoints.depotsApi.getAll, {
          key: 'study_id',
          value: study_id
        })}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    })
  })
});

export const drugSupplyApi = createApi({
  baseQuery,
  reducerPath: 'drugSupplyApi',
  endpoints: builder => ({
    createBulkDrugSuppply: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data }) => ({
        url: `${formatString(endPoints.drugSupply.bulkCreate, {
          key: 'study_id',
          value: study_id
        })}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    }),
    getAllDrugSupply: builder.mutation<any, any>({
      query: ({
        study_id,
        application,
        application_section,
        application_module_section,
        data,
        from,
        size,
        is_country_based_data = false,
        is_received_data = false
      }) => ({
        url: `${formatString(endPoints.drugSupply.getAll, {
          key: 'study_id',
          value: study_id
        })}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}&is_country_based_data=${is_country_based_data}&is_received_data=${is_received_data}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      })
    }),
    getDrugSupply: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, drug_supply_id }) => ({
        url: `${formatString(
          endPoints.drugSupply.select,
          {
            key: 'study_id',
            value: study_id
          },
          {
            key: 'drug_supply_id',
            value: drug_supply_id
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    }),
    updateBulkDrugSuppply: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data, drug_supply_id }) => ({
        url: `${formatString(
          endPoints.drugSupply.update,
          {
            key: 'study_id',
            value: study_id
          },
          {
            key: 'drug_supply_id',
            value: drug_supply_id
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      })
    }),
    createDrugSuppplyDoc: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data, drug_supply_id }) => ({
        url: `${formatString(endPoints.drugSupply.createWithDoc, {
          key: 'drug_supply_id',
          value: drug_supply_id
        })}?study_id=${study_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    }),
    deleteSuppplyDoc: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data, drug_supply_id }) => ({
        url: `${formatString(endPoints.drugSupply.deleteSupplyDoc, {
          key: 'drug_supply_id',
          value: drug_supply_id
        })}?study_id=${study_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PATCH',
        body: data
      })
    }),
    deleteDrugSuppply: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data, drug_supply_id }) => ({
        url: `${formatString(
          endPoints.drugSupply.delete,
          {
            key: 'study_id',
            value: study_id
          },
          {
            key: 'drug_supply_id',
            value: drug_supply_id
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PATCH',
        body: data
      })
    }),
    shipDrugSuppply: builder.mutation<any, any>({
      query: ({ study_id, site_id, country, application, application_section, application_module_section, data }) => ({
        url: `${formatString(
          endPoints.drugSupply.ship
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    }),
    getAllPendingShipment: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, data, from, size }) => ({
        url: `${formatString(endPoints.drugSupply.pendingShipment, {
          key: 'study_id',
          value: study_id
        })}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      })
    }),
    shipStatus: builder.mutation<any, any>({
      query: ({ study_id, drug_supply_id, application, application_section, application_module_section, data }) => ({
        url: `${formatString(
          endPoints.drugSupply.shipStatus,

          {
            key: 'drug_supply_id',
            value: drug_supply_id
          }
        )}?study_id=${study_id}&drug_supply_id=${drug_supply_id}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET',
        body: data
      })
    }),

    updateDrugSupplyQuantity: builder.mutation<any, any>({
      query: ({ drug_supply_id, study_id, application, application_section, application_module_section, data }) => ({
        url: `${formatString(
          endPoints.drugSupply.updateQuantity,
          {
            key: 'drug_supply_id',
            value: drug_supply_id
          },
          {
            key: 'study_id',
            value: study_id
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      })
    }),
    updateDrugSupplyStatus: builder.mutation<any, any>({
      query: ({ drug_supply_id, study_id, application, application_section, application_module_section, data }) => ({
        url: `${formatString(
          endPoints.drugSupply.updateStatus,
          {
            key: 'drug_supply_id',
            value: drug_supply_id
          },
          {
            key: 'study_id',
            value: study_id
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      })
    }),
    getCountryAccess: builder.mutation<any, any>({
      query: ({ study_id, application, application_section, application_module_section, transfer_to }) => ({
        url: `${formatString(
          endPoints.drugSupply.countryAccess,
          {
            key: 'study_id',
            value: study_id
          },
          {
            key: 'transfer_to',
            value: transfer_to
          }
        )}?application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    })
  })
});

export const {
  useCreateBulkDrugSuppplyMutation,
  useGetAllDrugSupplyMutation,
  useGetDrugSupplyMutation,
  useUpdateBulkDrugSuppplyMutation,
  useDeleteDrugSuppplyMutation,
  useGetAllPendingShipmentMutation,
  useCreateDrugSuppplyDocMutation,
  useDeleteSuppplyDocMutation,
  useShipDrugSuppplyMutation,
  useShipStatusMutation,
  useUpdateDrugSupplyQuantityMutation,
  useUpdateDrugSupplyStatusMutation,
  useGetCountryAccessMutation
} = drugSupplyApi;

export const { useGetStudyDetailsQuery, useGetAllDepotsMutation } = masterListApi;
